export default __webpack_public_path__ + "static/media/banner-background-features.5094732f.png";